import React, { memo, useCallback, useState } from 'react';

import { IPageEnd } from 'app/store/nodes/card/interfaces';
import Analytics from 'app/lib/Analytics/Analytics';
import { useDispatcher } from 'app/store/utils/redux/hooks';

import styles from './Reply.module.css';

interface ISendReply {
  data?: IPageEnd,
}

const Reply: React.FC<ISendReply> = memo((props) => {
  const dispatcher = useDispatcher();

  const [isSkipSend, setSkipSend] = useState(false);
  const [isActionSend, setActionSend] = useState(false);
  const [message, setMessage] = useState('');
  const [from, setFrom] = useState('');

  const hasFrom = Boolean(props?.data?.items?.reply?.hasFrom);
  const isSendEnabled = message.trim().length >= 1 && (hasFrom ? from.trim().length >= 2 : true);

  const handleFromChange = useCallback((event: any) => {
    setFrom(event.target.value);
  }, []);

  const handleMessageChange = useCallback((event: any) => {
    setMessage(event.target.value);
  }, []);

  const handleSkipReply = useCallback(() => {
    setSkipSend(true);
    dispatcher.lastPage.shiftStep();
    Analytics.track().tappedSkipReply();
  }, [dispatcher]);

  const handleSendMessage = useCallback(() => {
    setActionSend(true);
    dispatcher.lastPage.sendMessage(message, hasFrom ? from : undefined);
  }, [dispatcher, message, hasFrom, from]);

  return (
    <div className={styles.steps}>
      <div className={styles.header}>Write a Reply</div>
      <div className={styles.form}>
        {hasFrom && (
          <div className={`${styles.field} ${styles.fieldSep}`}>
            <input
              placeholder="From..."
              value={from}
              maxLength={30}
              onChange={handleFromChange}
            />
          </div>
        )}
        <div className={`${styles.field} ${styles.fieldFull}`}>
          <textarea
            placeholder="Add your reply here..."
            value={message}
            maxLength={1000}
            disabled={isActionSend}
            onChange={handleMessageChange}
          />
        </div>
        <div className={styles.buttons}>
          <button
            className={styles.next}
            type="button"
            disabled={isSkipSend}
            onClick={handleSkipReply}
          >
            <span>skip</span>
          </button>
          <button
            className={styles.send}
            type="button"
            disabled={isActionSend || !isSendEnabled}
            onClick={handleSendMessage}
          >
            send
          </button>
        </div>
      </div>
    </div>
  );
});

export default Reply;
